import script from "./ChatListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatListView.vue?vue&type=script&setup=true&lang=js"

import "./ChatListView.vue?vue&type=style&index=0&id=76409a4a&lang=scss"

const __exports__ = script;

export default __exports__